export enum SourcingLineStatus {
	PENDING = 'pending',
	PENDING_INFO = 'pending_info',
	VENDOR_IDENTIFIED = 'vendor_identified',
	RFQ_SENT = 'rfq_sent',
	PO_PLACED = 'po_placed',
	PARTIALLY_RECEIVED = 'partially_received',
	RECEIVED = 'received',
	FULFILLED = 'fulfilled',
	CANCELLED = 'cancelled',
}

export type SourcingLineStatusKey = keyof typeof SourcingLineStatus;
export type SourcingLineStatusValue =
	(typeof SourcingLineStatus)[SourcingLineStatusKey];

export const SourcingLineStatusLabels: Record<SourcingLineStatusValue, string> =
	{
		[SourcingLineStatus.PENDING]: 'Pending',
		[SourcingLineStatus.PENDING_INFO]: 'Pending Info',
		[SourcingLineStatus.VENDOR_IDENTIFIED]: 'Vendor Identified',
		[SourcingLineStatus.RFQ_SENT]: 'RFQ Sent',
		[SourcingLineStatus.PO_PLACED]: 'PO Placed',
		[SourcingLineStatus.PARTIALLY_RECEIVED]: 'Partially Received',
		[SourcingLineStatus.RECEIVED]: 'Received',
		[SourcingLineStatus.FULFILLED]: 'Fulfilled',
		[SourcingLineStatus.CANCELLED]: 'Cancelled',
	};

export function getSourcingLineStatusLabel(
	status: string | null | undefined,
): string {
	if (status == null) {
		return '-';
	}

	return (
		SourcingLineStatusLabels[status as SourcingLineStatusValue] ?? 'Unknown'
	);
}

export function getSourcingLineStatusColor(
	status: string | null | undefined,
): string {
	if (status == null) {
		return 'default';
	}

	switch (status) {
		case SourcingLineStatus.PENDING:
			return 'secondary';
		case SourcingLineStatus.PENDING_INFO:
			// Amber/warning to draw the eye — this status means the line
			// is parked waiting for a clarification, and someone (the
			// requestor) needs to act before the buyer can move it
			// forward. Same colour family as the SR-level "Coming Due"
			// signal so the visual language stays consistent.
			return 'warning';
		case SourcingLineStatus.VENDOR_IDENTIFIED:
			return 'info';
		case SourcingLineStatus.RFQ_SENT:
			return 'warning';
		case SourcingLineStatus.PO_PLACED:
			return 'primary';
		case SourcingLineStatus.PARTIALLY_RECEIVED:
			return 'warning';
		case SourcingLineStatus.RECEIVED:
			return 'info';
		case SourcingLineStatus.FULFILLED:
			return 'success';
		case SourcingLineStatus.CANCELLED:
			return 'danger';
		default:
			return 'default';
	}
}
